export default "__VITE_ASSET__3hxxzhY0__"